import { render, staticRenderFns } from "./ExtraPagePositionInputDialog.vue?vue&type=template&id=7a3dde6a&scoped=true&"
import script from "./ExtraPagePositionInputDialog.vue?vue&type=script&lang=ts&"
export * from "./ExtraPagePositionInputDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraPagePositionInputDialog.vue?vue&type=style&index=0&id=7a3dde6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3dde6a",
  null
  
)

export default component.exports